export interface ITreatmentAssignmentApiModel {
  treatmentId: string;
  employeeId: string;
}
